/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { DesignsStore } from './types';

export const designsStoreSelector = {
  designElements: (state: DesignsStore) => state.designElements,
  folderElements: (state: DesignsStore) => state.folderElements,
  active: (state: DesignsStore) => state.active, // designId
  activeFolder: (state: DesignsStore) => state.activeFolder,
  fetchDesigns: (state: DesignsStore) => state.fetchDesigns,
  fetchFolders: (state: DesignsStore) => state.fetchFolders,
  isFetchingDesigns: (state: DesignsStore) => state.isFetchingDesigns,
  isFetchingFolders: (state: DesignsStore) => state.isFetchingFolders,
  totalDesigns: (state: DesignsStore) => state.totalDesigns,
  totalFolders: (state: DesignsStore) => state.totalFolders,
  useFolder: (
    state: DesignsStore
  ): [DesignsStore['activeFolder'], DesignsStore['setFolder']] => [
    state.activeFolder,
    state.setFolder,
  ],
  folderDesigns: (state: DesignsStore) => state.folderDesigns,
  folderTotal: (state: DesignsStore) => state.folderTotal,
  folderFetch: (state: DesignsStore) => state.fetchFolder,
  folderIsFetching: (state: DesignsStore) => state.folderIsFetching,
  setActive: (state: DesignsStore) => state.setActive,
  insertElement: (state: DesignsStore) => state.insertElement,
  updateElement: (state: DesignsStore) => state.updateElement,
  updateFolder: (state: DesignsStore) => state.updateFolder,
  deleteElement: (state: DesignsStore) => state.deleteElement,
  reset: (state: DesignsStore) => state.reset,
  activeDesign: (state: DesignsStore) => state.activeDesign,
  isActiveModified: (state: DesignsStore) => state.isActiveModified,
  canUserCreateDesign: (state: DesignsStore) => state.canUserCreateDesign,
  closeProjectListModal: (state: DesignsStore) => state.closeProjectListModal,
  setAddToExistingDesignParams: (state: DesignsStore) =>
    state.setAddToExistingDesignParams,
  setShowProjectListModal: (state: DesignsStore) =>
    state.setShowProjectListModal,
  projectListModalProps: (state: DesignsStore) => ({
    isOpen: state.showProjectListModal,
    closeModal: state.closeProjectListModal,
    addToExistingDesignParams: state.addToExistingDesignParams,
  }),
  forceActiveModified: (state: DesignsStore) => state.forceActiveModified,
  updateDesignLocks: (state: DesignsStore) => state.updateDesignLocks,
};
